



































































































import { Vue, Component } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import {
  VIDEO_VAULT_PAGE,
  BUDTENDER_PORTAL,
  TOP_PUBLIC_BAR,
  ADMIN_BRAND_ASSETS,
} from '../../common/routes.config';
import budtenderModule from '../../store/modules/budtender.module';
import { ASSET_URL, VIDEO_ID } from '../../common/config';
import adminModule from '../../store/modules/admin.module';
import brandModule from '../../store/modules/brand.module';

@Component({
  components: {},
})
export default class PublicNavbar extends Vue {
  drawer: boolean | null = null;

  cdnUrl = ASSET_URL;

  get pages() {
    let pages: Array<RouteConfig> = TOP_PUBLIC_BAR;
    if (!brandModule.brand) {
      return pages;
    }
    if (!brandModule.brand.brand_assets) {
      return pages;
    }
    const brandVideos = brandModule.brand.brand_assets.filter((asset) => {
      if (!asset.category) {
        return false;
      }
      return asset.category.id === VIDEO_ID;
    });
    if (brandVideos.length > 0) {
      pages = [...pages, VIDEO_VAULT_PAGE];
    }
    if (!brandModule.brand.products) {
      return pages;
    }
    if (brandModule.brand.products.length < 0) {
      pages = [...pages];
    }
    return pages;
  }

  get budtenderHome(): RouteConfig {
    if (adminModule.admin) {
      return ADMIN_BRAND_ASSETS;
    }
    return BUDTENDER_PORTAL;
  }

  get brandColor(): string {
    if (!budtenderModule.selectedBrand || !budtenderModule.selectedBrand.primary_color) {
      return '';
    }
    return budtenderModule.selectedBrand.primary_color;
  }

  get brandFontColor(): string {
    if (
      !budtenderModule.selectedBrand
      || !budtenderModule.selectedBrand.font_color
    ) {
      return '#FFFFFF';
    }
    return budtenderModule.selectedBrand.font_color;
  }

  get brandLogo(): string {
    if (!budtenderModule.selectedBrand) { return ''; }
    return budtenderModule.selectedBrand.logo;
  }
}
